// src/store.js 7/3/25 updated by GROk
// again rewrite grk
import { configureStore } from '@reduxjs/toolkit';
//import { createReduxHistoryContext } from 'redux-first-history';
//import history from './utils/history';
import createRootReducer from './reducers';
//import { createBrowserHistory } from 'history';// for debug of history

const store = configureStore({
  reducer: createRootReducer(),
  middleware: (getDefaultMiddleware) =>  getDefaultMiddleware(),
});
//const reduxHistory = createReduxHistory(store);


console.log('[Debug] Store created:', store.getState());
export { store };

